import {
	Box,
	Collapse,
	Fade,
	ListSubheader,
	SxProps,
	Theme
} from '@mui/material';
import React, { FC } from 'react';
import { IProps } from 'types/common';

interface INavigationMenuListSubHeaderProps extends IProps {
	isOpen: boolean;
	valueSx?: SxProps<Theme>;
}

const NavigationMenuListSubHeader: FC<INavigationMenuListSubHeaderProps> = ({
	children,
	isOpen,
	valueSx
}) => (
	<ListSubheader
		sx={{
			textTransform: 'uppercase',
			textOverflow: 'ellipsis',
			fontWeight: 700,
			color: 'text.secondary',
			fontSize: '12px',
			bgcolor: 'transparent',
			lineHeight: '12px',
			width: '100%',
			marginBottom: 1,
			marginTop: 1,
			paddingLeft: 2,
			paddingRight: 0,
			minWidth: undefined,
			display: 'flex',
			...valueSx
		}}
	>
		<Collapse orientation="horizontal" in={isOpen} timeout={200}>
			<Fade in={isOpen} timeout={200}>
				<Box display="flex" flexGrow={1} justifyContent="flex-start">
					{children}
				</Box>
			</Fade>
		</Collapse>
	</ListSubheader>
);

NavigationMenuListSubHeader.defaultProps = {
	valueSx: {}
};

export default NavigationMenuListSubHeader;
